import { CircleHelp } from "lucide-react";
import React from "react";

import {
  IgButton,
  IgPaper,
  IgTooltip,
  IgTypography,
} from "@intelligems/ig-theme";
import { Grid, IconButton } from "@mui/material";
import { useRefreshShopifyScopes } from "@src/api/user-auths/login";

export const AdvancedActions = () => {
  const refreshShopifyCredentials = useRefreshShopifyScopes();
  const tooltipMessage =
    "Sync shopify scope permissions to update the scopes Intelligems has access to";
  return (
    <Grid item>
      <IgPaper>
        <Grid container direction={"row"} rowSpacing={3}>
          <Grid container item>
            <Grid item xs>
              <IgTypography variant="h3" fontWeight={"fontWeightMedium"}>
                Advanced Actions
              </IgTypography>
            </Grid>
          </Grid>
          <Grid container item alignItems="center" columnSpacing={1}>
            <Grid item>
              <Grid
                container
                alignItems="center"
                wrap="nowrap"
                columnSpacing={0.5}
              >
                <Grid item>
                  <IgTypography>Sync Shopify Permissions</IgTypography>
                </Grid>
                <Grid item>
                  <IgTooltip title={tooltipMessage}>
                    <IconButton size="small" aria-label="info">
                      <CircleHelp size={16} />
                    </IconButton>
                  </IgTooltip>
                </Grid>
              </Grid>
            </Grid>

            <Grid item>
              <IgButton
                variant="outlined"
                onClick={() => refreshShopifyCredentials.mutate({})}
                loading={refreshShopifyCredentials.isPending}
              >
                Sync
              </IgButton>
            </Grid>
          </Grid>
        </Grid>
      </IgPaper>
    </Grid>
  );
};
